<template>
  <div class="create__customer">
    <vs-popup id="create_customer" classContent="popup-example" title="Add Customer" :active.sync="is_create_customer_popup_active">
      <form @submit.prevent="addCustomer">
        <!-- create customer form -->
        <div class="vx-row create_customer_content p-1">
          <div class="vx-col w-full">
            <!-- customer type -->
            <div class="customer_type mb-2 w-full">
              <label for="customer_type">Customer Type</label>
              <select-2
                class="w-3/5"
                id="customer_type"
                autocomplete
                :value="add_customer_type"
                @input="(item) => (add_customer_type = item.value)"
                placeholder="Please Select Customer Type"
                :options="customertypes"
              />
            </div>
          </div>
        </div>

        <!-- Add Client Form Start -->
        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'client'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Bussiness Name -->
            <div class="business_name mb-2 w-full">
              <label for="business_name">Bussiness Name *</label>
              <vs-input class="w-full" placeholder="Enter Bussiness Name" v-model="add_client.business_name" name="Bussiness Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Bussiness Name')">{{ errors.first('Bussiness Name') }}</span>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Phone -->
            <div class="phone mb-2 w-full">
              <label for="phone">Phone</label>
              <vs-input class="w-full" placeholder="Enter Phone Number" v-model="add_client.phone" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Email -->
            <div class="email mb-2 w-full">
              <label for="email">Email</label>
              <vs-input class="w-full" placeholder="Enter Email Id" v-model="add_client.email" name="Email Id" v-validate="'email'" />
              <span class="text-danger text-sm" v-show="errors.has('Email Id')">{{ errors.first('Email Id') }}</span>
            </div>
          </div>
        </div>

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'client'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- License Number -->
            <div class="license_number mb-2 w-full">
              <label for="license_number">License Number</label>
              <vs-input class="w-full" placeholder="Enter License Number" v-model="add_client.license_number" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- zip code -->
            <div class="zip_code mb-2 w-full">
              <label for="zip_code">Zip Code</label>
              <vs-input class="w-full" placeholder="Enter Zip Code" v-model="add_client.zip_code" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Role -->
            <div class="role mb-2 w-full">
              <label for="role">Role *</label>
              <select-2
                class="w-full"
                id="role"
                autocomplete
                :value="add_client.role"
                @input="(item) => (add_client.role = item.value)"
                placeholder="Please Select Client Role Type"
                :options="role_options"
                name="Role"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Role')">{{ errors.first('Role') }}</span>
            </div>
          </div>
        </div>

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'client'">
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <!-- State -->
            <div class="state mb-2 w-full">
              <label for="state">State</label>
              <vs-input class="w-full" placeholder="Enter State Name" v-model="add_client.state" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <!-- city -->
            <div class="city mb-2 w-full">
              <label>City</label>
              <select-2
                :ssr="false"
                class="w-full"
                :value="add_client.cityId"
                @input="(item) => (add_client.cityId = item && item.value)"
                label-placeholder="City"
                name="City"
                placeholder="Select City"
                action="getCityOptions"
              />
            </div>
          </div>
        </div>
        <!-- Add Client Form End -->

        <!-- Add Patient Form Start -->
        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'patient'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- First Name -->
            <div class="first_name mb-2 w-full">
              <label for="first_name">First Name *</label>
              <vs-input class="w-full" placeholder="Enter First Name" v-model="add_patient.first_name" name="First Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Last Name -->
            <div class="last_name mb-2 w-full">
              <label for="last_name">Last Name *</label>
              <vs-input class="w-full" placeholder="Enter Last Name" v-model="add_patient.last_name" name="Last Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Phone -->
            <div class="phone mb-2 w-full">
              <label for="phone">Phone Number</label>
              <vs-input class="w-full" placeholder="Enter Phone Number" v-model="add_patient.phone" />
            </div>
          </div>
        </div>

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'patient'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Email -->
            <div class="email mb-2 w-full">
              <label for="email">Email</label>
              <vs-input class="w-full" placeholder="Enter Email Id" v-model="add_patient.email" name="Email" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- License Number -->
            <div class="license_number mb-2 w-full">
              <label for="license_number">License Number *</label>
              <vs-input class="w-full" placeholder="Enter License Number" v-model="add_patient.license_number" name="License Number" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('License Number')">{{ errors.first('License Number') }}</span>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- License Expiry Date -->
            <div class="license_expiry_date mb-2 w-full relative">
              <label for="license_expiry_date">License Expiry Date</label>
              <date-picker :appendToBody="false" v-model="add_patient.license_expiry_date" placeholder="MM-DD-YYYY" name="License Expiry Date" format="MM-DD-YYYY" valueType="format" class="w-full" />
            </div>
          </div>
        </div>

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'patient'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- date of birth -->
            <div class="dob mb-2 w-full relative">
              <label for="dob">DOB</label>
              <date-picker :appendToBody="false" v-model="add_patient.dob" placeholder="MM-DD-YYYY" format="MM-DD-YYYY" name="Birth Date" valueType="format" class="w-full" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- Monthly Limit -->
            <div class="monthly_limit mb-2 w-full">
              <label for="monthly_limit">Monthly Limit</label>
              <vs-input class="w-full" placeholder="Enter Monthly Limit" v-model="add_patient.monthly_limit" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- patient -->
            <div class="patient mb-2 w-full">
              <label for="patient">Patient *</label>
              <select-2
                class="w-full"
                id="patient"
                autocomplete
                :value="add_patient.patient_type"
                @input="(item) => (add_patient.patient_type = item.value)"
                placeholder="Please Select Patient Type"
                :options="patient_types_options"
                name="Patient Type"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Patient Type')">{{ errors.first('Patient Type') }}</span>
            </div>
          </div>
        </div>

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type === 'patient'">
          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- State -->
            <div class="state mb-2 w-full">
              <label for="state">State</label>
              <vs-input class="w-full" placeholder="Enter State Name" v-model="add_patient.state" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- city -->
            <div class="city mb-2 w-full">
              <label>City</label>
              <select-2
                :ssr="false"
                class="w-full"
                :value="add_patient.cityId"
                @input="(item) => (add_patient.cityId = item && item.value)"
                label-placeholder="City"
                name="City"
                placeholder="Select City"
                action="getCityOptions"
              />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/3 sm:w-full">
            <!-- zip code -->
            <div class="zip_code mb-2 w-full">
              <label for="zip_code">Zip Code</label>
              <vs-input class="w-full" placeholder="Enter Zip Code" v-model="add_patient.zip_code" />
            </div>
          </div>
        </div>
        <!-- Add Patient Form End -->

        <div class="vx-row create_customer_content p-1" v-if="add_customer_type">
          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <!-- Addredss -->
            <div class="address mb-2 w-full">
              <label for="address">Address</label>
              <vs-textarea class="w-full" v-model="add_customer_address" />
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/2 sm:w-full">
            <!-- Note -->
            <div class="note mb-2 w-full">
              <label for="note">Note</label>
              <vs-textarea class="w-full" v-model="add_customer_note" />
            </div>
          </div>
        </div>

        <!-- footer -->
        <div class="footer text-right" v-if="add_customer_type">
          <vs-button class="mt-2 text-sm p-3" color="danger" type="filled" @click="$emit('update:is_popup_active_create_customer', false)"> Close </vs-button>

          <button class="mt-2 ml-2 text-sm vs-component vs-button vs-button-primary vs-button-filled p-3" type="submit" :disabled="!validateForm">Save</button>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { patientTypes, clientRoleOptions } from '@/utils/enums'

export default {
  name: 'CreateCustomer',

  props: {
    is_popup_active_create_customer: Boolean
  },

  components: {
    DatePicker,
    Select2
  },

  data() {
    return {
      add_customer_type: null,

      // customer types otions
      customertypes: [
        {
          label: 'Client',
          value: 'client'
        },
        {
          label: 'Patient',
          value: 'patient'
        }
      ],

      add_customer_address: '',
      add_customer_note: '',
      date: 'MM-dd-yyyy',

      // add client
      add_client: {
        business_name: '',
        phone: '',
        email: '',
        license_number: null,
        zip_code: '',
        role: '',
        state: '',
        cityId: null
      },

      // add patient
      add_patient: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        license_number: '',
        license_expiry_date: null,
        dob: null,
        monthly_limit: '',
        patient_type: '',
        state: '',
        cityId: null,
        zip_code: ''
      },

      role_options: clientRoleOptions,
      patient_types_options: patientTypes
    }
  },

  computed: {
    ...mapState('client', { loading: 'loading' }),
    ...mapState('patient', { loading: 'loading' }),

    // validate form
    validateForm() {
      return !this.errors.any()
    },

    // close the poup
    is_create_customer_popup_active: {
      get() {
        return this.is_popup_active_create_customer
      },
      set(val) {
        this.$emit('update:is_popup_active_create_customer', val)
      }
    }
  },

  methods: {
    ...mapActions('client', { insertCustomer: 'insert' }),
    ...mapActions('patient', { insertpatient: 'insert' }),

    // add customer
    async addCustomer() {
      if (!(await this.$validator.validate())) {
        return false
      }

      // add client
      if (this.add_customer_type === 'client') {
        const data = this.add_client

        data.address = this.add_customer_address
        data.postcode = data.zip_code

        try {
          const { message } = await this.insertCustomer({
            ...data
          })

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.add_customer_address = ''
          this.add_customer_note = ''
          this.add_client = {
            business_name: '',
            phone: '',
            email: '',
            license_number: '',
            zip_code: '',
            role: '',
            state: '',
            cityId: null
          }
          this.$validator.reset()

          this.$nextTick(() => {
            this.add_customer_type = null
            this.$emit('updateCustomerList')
            this.$emit('update:is_popup_active_create_customer', false)
          })
        } catch ({ message }) {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      }

      // add patient
      if (this.add_customer_type === 'patient') {
        const data = this.add_patient

        data.address = this.add_customer_address
        data.postcode = data.zip_code

        try {
          const { message } = await this.insertpatient({
            ...data
          })

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.add_customer_address = ''
          this.add_customer_note = ''
          this.add_patient = {
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            license_number: '',
            license_expiry_date: null,
            dob: null,
            monthly_limit: '',
            patient_type: '',
            state: '',
            cityId: null,
            zip_code: ''
          }
          this.$validator.reset()

          this.$nextTick(() => {
            this.add_customer_type = null
            this.$emit('updateCustomerList')
            this.$emit('update:is_popup_active_create_customer', false)
          })
        } catch ({ message }) {
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      }

      return false
    }
  },

  watch: {
    // set loading
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.create__customer',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.create__customer > .con-vs-loading')
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.is_create_customer_popup_active = false
    next()
  }
}
</script>

<style lang="scss">
#create_customer {
  .vs-popup {
    width: calc(100% - 30%) !important;
  }
  .vs-popup--header {
    background: rgb(0, 102, 34);
    border-radius: unset;
    padding: 0px;

    h3 {
      color: #fff;
      text-align: center;
    }
  }
}
</style>
